module.exports = __webpack_public_path__ + "media/assets/images/letter-6db6311ce583048daebbf9dbb32fedcb.svg";